import { App } from 'vue'
import ValueChangeTracker from "@/editor/ValueChangeTracker.vue";
import EditNone from '@/editor/EditNone.vue'
import EditTextArea from '@/editor/EditTextArea.vue'
import EditTitel from '@/editor/EditTitel.vue'
import EditSlider from '@/editor/EditSlider.vue'
import EditCheckBox from '@/editor/EditCheckBox.vue'
import EditTextField from '@/editor/EditTextField.vue'
import EditBild from './EditBild.vue'
import EditCheckBox3 from '@/editor/EditCheckBox3.vue'
import EditChoiceColor from '@/editor/EditChoiceColor.vue'
import EditGps from '@/editor/EditGps.vue'
import EditFiller from './EditFiller.vue'
import EditRadioButtons from './EditRadioButtons.vue'
import EditSwitchButton from '@/editor/EditSwitchButton.vue'
import EditFileChoicer from '@/editor/EditFileChoicer.vue'
import EditZahl from '@/editor/EditZahl.vue'
import EditWaehrung from '@/editor/EditWaehrung.vue'
import EditComboBox from './EditComboBox.vue'
import EditToggleSight from '@/editor/EditToggleSight.vue'
import EditHierarchie from '@/editor/EditHierarchie.vue'
import EditDatePicker from '@/editor/EditDatePicker.vue'
import EditDateTimePicker from '@/editor/EditDateTimePicker.vue'
import EditTimePicker from '@/editor/EditTimePicker.vue'
import EditDateRange from '@/editor/EditDateRange.vue'
import EditDateRange2 from '@/editor/EditDateRange2.vue'
import EditVonBis from '@/editor/EditVonBis.vue'
import EditMass from '@/editor/EditMass.vue'
/*
import EditComboBox from '@/editor/EditComboBox.vue'
import EditComboBoxItem from '@/editor/EditComboBoxItem.vue'

import EditVonBis from '@/editor/EditVonBis.vue'

*/

function registerEditorComponent(app: App<Element>, component: any) {
    app.component(component.__name, component);
}

export function getEditorComponents() {return  [
    ValueChangeTracker,
    EditBild,
    EditNone,
    EditTextArea,
    EditTextField,
    EditTitel,
    EditSlider,
    EditCheckBox,
    EditCheckBox3,
    EditChoiceColor,
    EditGps,
    EditFiller,
    EditRadioButtons,
    EditSwitchButton,
    EditFileChoicer,
    EditZahl,
    EditWaehrung,
    EditComboBox,
    EditToggleSight,
    EditHierarchie,
    EditDatePicker,
    EditDateTimePicker,
    EditTimePicker,
    EditDateRange,
    EditDateRange2,
    EditVonBis,
    EditMass
];}

export function registerEditorComponents(app: App<Element>) {
    getEditorComponents().forEach(c => registerEditorComponent(app, c));
}

export {
    ValueChangeTracker
    , EditNone
    , EditTextArea
    , EditTextField
    , EditTitel
    , EditSlider
    , EditCheckBox
    , EditBild
    , EditCheckBox3
    , EditChoiceColor
    , EditGps
    , EditFiller
    , EditRadioButtons
    , EditSwitchButton
    , EditFileChoicer
    , EditZahl
    , EditWaehrung
    , EditComboBox
    , EditToggleSight
    , EditHierarchie
    , EditDatePicker
    , EditDateTimePicker
    , EditTimePicker
    , EditDateRange
    , EditDateRange2
}

